<script setup lang="ts">
// lilaliba.com landing page; all copy comes from the backend translations (platform.marketing.*)
definePageMeta({layout: 'platform'})

const {t} = useI18n()
const localePath = useLocalePath()

useSeoMeta({
  title: function marketingTitle() {
    return t('platform.marketing.metaTitle')
  },
  description: function marketingDescription() {
    return t('platform.marketing.metaDescription')
  },
})

const links = computed(function buildLinks() {
  return [
    {label: t('platform.marketing.ctaPrimary'), to: localePath('/signup'), size: 'xl' as const},
    {
      label: t('platform.marketing.ctaSecondary'),
      to: localePath('/login'),
      size: 'xl' as const,
      color: 'neutral' as const,
      variant: 'outline' as const,
    },
  ]
})

const features = computed(function buildFeatures() {
  return [
    {title: t('platform.marketing.storesTitle'), description: t('platform.marketing.storesText')},
    {title: t('platform.marketing.themeTitle'), description: t('platform.marketing.themeText')},
    {title: t('platform.marketing.safeTitle'), description: t('platform.marketing.safeText')},
  ]
})
</script>

<template>
  <div>
    <UPageHero
        :title="t('platform.marketing.heroTitle')"
        :description="t('platform.marketing.heroText')"
        :links="links"
    />
    <UPageSection :title="t('platform.marketing.featuresTitle')" :features="features"/>
  </div>
</template>
